/**
 * Localización en Español para FaceTec Browser SDK
 *
 * Este archivo contiene todas las traducciones al español
 * para los textos de la interfaz de FaceTec.
 */
export var FACETEC_SPANISH_STRINGS = {
    // Botones de Acción
    "FaceTec_action_im_ready": "Estoy Listo",
    "FaceTec_action_try_again": "Intentar Nuevamente",
    "FaceTec_action_continue": "Continuar",
    "FaceTec_action_take_photo": "Tomar Foto",
    "FaceTec_action_accept_photo": "Aceptar",
    "FaceTec_action_retake_photo": "Volver a Tomar",
    "FaceTec_action_confirm": "Confirmar",
    "FaceTec_action_ok": "OK",
    // Accesibilidad
    "FaceTec_accessibility_cancel_button": "Cancelar",
    "FaceTec_accessibility_tap_guidance": "Toque dos veces para obtener ayuda",
    "FaceTec_accessibility_key_down_guidance": "Presione la tecla de flecha hacia abajo para obtener ayuda",
    // Mensajes de Retroalimentación Durante el Escaneo Facial
    "FaceTec_feedback_center_face": "Centre su Rostro",
    "FaceTec_feedback_face_not_found": "Encuadre su Rostro",
    "FaceTec_feedback_move_phone_away": "Aléjese",
    "FaceTec_feedback_move_away_web": "Aléjese",
    "FaceTec_feedback_move_phone_closer": "Acérquese",
    "FaceTec_feedback_move_web_closer": "Acérquese a la Cámara",
    "FaceTec_feedback_move_web_even_closer": "Aún Más Cerca",
    "FaceTec_feedback_move_phone_to_eye_level": "Suba el Teléfono a la Altura de los Ojos",
    "FaceTec_feedback_use_even_lighting": "Iluminación Más Uniforme",
    "FaceTec_feedback_frame_your_face": "Encuadre su Rostro",
    "FaceTec_feedback_hold_steady": "Manténgase Quieto",
    "FaceTec_feedback_move_phone_even_closer": "Más Cerca",
    "FaceTec_feedback_face_not_looking_straight_ahead": "Mire al Frente",
    "FaceTec_feedback_face_not_upright": "Mantenga la Cabeza Derecha",
    "FaceTec_feedback_face_not_upright_mobile": "Mantenga la Cabeza Derecha",
    "FaceTec_feedback_hold_steady1s": "Manténgase Quieto: 1s",
    "FaceTec_feedback_hold_steady2s": "Manténgase Quieto: 2s",
    "FaceTec_feedback_hold_steady3s": "Manténgase Quieto: 3s",
    "FaceTec_feedback_eyes_straight_ahead": "Mire al Frente",
    "FaceTec_feedback_remove_dark_glasses": "Quítese los Lentes Oscuros",
    "FaceTec_feedback_neutral_expression": "Expresión Neutral, Sin Sonreír",
    "FaceTec_feedback_conditions_too_bright": "Demasiada Luz",
    "FaceTec_feedback_brighten_your_environment": "Iluminación Demasiado Baja",
    // Pantalla de Preparación (Ready Screen)
    "FaceTec_presession_frame_your_face": "Encuadre su Rostro en el Óvalo",
    "FaceTec_presession_look_straight_ahead": "Mire Directamente al Frente",
    "FaceTec_presession_hold_steady3": "Manténgase Quieto por 3 Segundos",
    "FaceTec_presession_position_face_straight_in_oval": "Posicione su Rostro en el Óvalo",
    "FaceTec_presession_eyes_straight_ahead": "Mire al Frente",
    "FaceTec_presession_remove_dark_glasses": "Quítese los Lentes Oscuros",
    "FaceTec_presession_neutral_expression": "Expresión Neutral, Sin Sonreír",
    "FaceTec_presession_conditions_too_bright": "Ambiente Demasiado Brillante",
    "FaceTec_presession_brighten_your_environment": "Ambiente Demasiado Oscuro",
    // Instrucciones de inicio
    "FaceTec_instructions_header_ready": "Prepárese para su verificación",
    "FaceTec_instructions_message_ready": "Encuadre su rostro en el óvalo, Presione Estoy Listo y Acérquese",
    // Mensajes de Resultado
    "FaceTec_result_facescan_upload_message": "Subiendo<br/>Escaneo Facial Encriptado",
    "FaceTec_result_idscan_upload_message": "Subiendo<br/>Documento Encriptado",
    "FaceTec_result_success_message": "Éxito",
    "FaceTec_result_uploading_message": "Subiendo<br/>Información Encriptada",
    "FaceTec_result_success_message_header": "Rostro Escaneado",
    "FaceTec_result_facescan_success_message": "Rostro Escaneado",
    "FaceTec_result_liveness_proven_message": "Verificación 3D Completada",
    // Escaneo de Documento de Identidad
    "FaceTec_idscan_type_selection_header": "Capture su<br/>Documento de Identidad",
    "FaceTec_idscan_capture_id_front_instruction_message": "Muestre el Frente de su Documento",
    "FaceTec_idscan_capture_id_back_instruction_message": "Muestre el Reverso de su Documento",
    "FaceTec_idscan_review_id_front_instruction_message": "Confirme que la Foto es Clara y Legible",
    "FaceTec_idscan_review_id_back_instruction_message": "Confirme que la Foto es Clara y Legible",
    "FaceTec_idscan_additional_review_message": "Revisión Adicional<br/>Necesaria",
    "FaceTec_idscan_ocr_confirmation_main_header": "Revise y Confirme",
    "FaceTec_idscan_ocr_confirmation_scroll_message": "Desplácese para Ver Todos los Campos",
    // Tipos de Documento
    "FaceTec_idscan_type_id_card": "Cédula de Identidad",
    "FaceTec_idscan_type_passport": "Pasaporte",
    "FaceTec_idscan_type_drivers_license": "Licencia de Conducir",
    // Pantalla de Reintento
    "FaceTec_retry_header": "Intentemos<br/>Nuevamente",
    "FaceTec_retry_subheader_message": "Necesitamos una Foto Más Clara",
    "FaceTec_retry_your_image_label": "Su Selfie",
    "FaceTec_retry_ideal_image_label": "Pose Ideal",
    "FaceTec_retry_instruction_message": "Por favor use pose e iluminación ideal",
    "FaceTec_retry_your_image_did_not_meet_standards": "Su Imagen No Cumplió con los Estándares",
    "FaceTec_retry_face_not_fully_visible": "Rostro No Completamente Visible",
    "FaceTec_retry_lighting_too_low": "Iluminación Demasiado Baja",
    "FaceTec_retry_lighting_too_extreme": "Iluminación Demasiado Extrema",
    "FaceTec_retry_id_not_fully_visible": "Documento No Completamente Visible",
    "FaceTec_retry_id_not_horizontal": "Documento No Horizontal",
    "FaceTec_retry_id_type_not_supported": "Tipo de Documento No Soportado",
    "FaceTec_retry_id_glare_detected": "Reflejo Detectado en el Documento",
    "FaceTec_retry_id_barcode_not_read": "Código de Barras No Leído",
    // Mensajes de Cancelación
    "FaceTec_camera_feed_issue_header": "Problema con la Cámara",
    "FaceTec_camera_feed_issue_subheader_message": "No se Puede Conectar a la Cámara",
    "FaceTec_camera_feed_issue_advice": "Verifique los Permisos de la Cámara",
    "FaceTec_camera_feed_issue_table_header": "Posibles Causas:",
    "FaceTec_camera_feed_issue_table_row_1_cell_1_firefox_permissions_error": "Permisos de Cámara no Otorgados en Firefox.",
    "FaceTec_camera_feed_issue_table_row_1_cell_2_firefox_permissions_error": "Haga clic en el ícono de cámara tachado en la barra de direcciones y seleccione \"No Bloquear\".",
    "FaceTec_camera_feed_issue_table_row_1_cell_1": "La cámara ya está en uso.",
    "FaceTec_camera_feed_issue_table_row_1_cell_2": "Cierre otras aplicaciones que usan la cámara.",
    "FaceTec_camera_feed_issue_table_row_2_cell_1": "Una extensión del navegador está bloqueando el acceso a la cámara.",
    "FaceTec_camera_feed_issue_table_row_2_cell_2": "Deshabilite extensiones de privacidad o cambios a la configuración del navegador.",
    "FaceTec_camera_feed_issue_table_row_3_cell_1": "La cámara no está disponible o no es compatible con este navegador.",
    "FaceTec_camera_feed_issue_table_row_3_cell_2": "Intente usar una cámara diferente o actualice su navegador.",
    "FaceTec_camera_feed_issue_subtable_message": "Este sitio requiere acceso a la cámara para capturar imágenes de verificación biométrica.",
    // Inicialización
    "FaceTec_init_camera_permissions_header": "Habilitar Cámara",
    "FaceTec_init_camera_permissions_message": "Se Requieren Permisos de Cámara",
    "FaceTec_init_message": "Inicializando...",
    // Mensajes de Pantalla Completa
    "FaceTec_enter_fullscreen_header": "Modo de Escaneo<br/>de Pantalla Completa",
    "FaceTec_enter_fullscreen_message": "Antes de comenzar, presione el botón a continuación para abrir el modo de pantalla completa.",
    "FaceTec_enter_fullscreen_action": "Abrir Pantalla Completa",
    // Otros
    "FaceTec_action_accept": "Aceptar",
    "FaceTec_accessibility_cancel": "Cancelar",
    "FaceTec_accessibility_feedback_move_phone_closer": "Acérquese al dispositivo",
    "FaceTec_accessibility_feedback_move_phone_away": "Aléjese del dispositivo",
};
/**
 * Traducciones para el OCR de documentos (campos del formulario)
 */
export var FACETEC_OCR_SPANISH = {
    "groups": [
        {
            "groupFriendlyName": "Su Información",
            "fields": [
                {
                    "fieldKey": "profession",
                    "fieldFriendlyName": "Profesión",
                    "uiFieldDescriptionText": "Profesión"
                },
                {
                    "fieldKey": "lastName",
                    "fieldFriendlyName": "Apellido",
                    "uiFieldDescriptionText": "Apellido"
                },
                {
                    "fieldKey": "firstName",
                    "fieldFriendlyName": "Nombre",
                    "uiFieldDescriptionText": "Nombre"
                },
                {
                    "fieldKey": "fullName",
                    "fieldFriendlyName": "Nombre Completo",
                    "uiFieldDescriptionText": "Nombre Completo"
                },
                {
                    "fieldKey": "dateOfBirth",
                    "fieldFriendlyName": "Fecha de Nacimiento",
                    "uiFieldDescriptionText": "Fecha de Nacimiento"
                },
                {
                    "fieldKey": "nationality",
                    "fieldFriendlyName": "Nacionalidad",
                    "uiFieldDescriptionText": "Nacionalidad"
                },
                {
                    "fieldKey": "sex",
                    "fieldFriendlyName": "Sexo",
                    "uiFieldDescriptionText": "Sexo"
                }
            ],
            "groupKey": "userInfo"
        },
        {
            "groupFriendlyName": "Su Dirección",
            "fields": [
                {
                    "fieldKey": "address1",
                    "fieldFriendlyName": "Dirección Línea 1",
                    "uiFieldDescriptionText": "Dirección Línea 1"
                },
                {
                    "fieldKey": "city",
                    "fieldFriendlyName": "Ciudad",
                    "uiFieldDescriptionText": "Ciudad"
                },
                {
                    "fieldKey": "commune",
                    "fieldFriendlyName": "Comuna",
                    "uiFieldDescriptionText": "Comuna"
                },
                {
                    "fieldKey": "region",
                    "fieldFriendlyName": "Región",
                    "uiFieldDescriptionText": "Región"
                },
                {
                    "fieldKey": "country",
                    "fieldFriendlyName": "País",
                    "uiFieldDescriptionText": "País"
                }
            ],
            "groupKey": "addressInfo"
        },
        {
            "groupFriendlyName": "Detalles del Documento",
            "fields": [
                {
                    "fieldKey": "idNumber",
                    "fieldFriendlyName": "RUT / Número de Documento",
                    "uiFieldDescriptionText": "RUT / Número de Documento"
                },
                {
                    "fieldKey": "dateOfIssue",
                    "fieldFriendlyName": "Fecha de Emisión",
                    "uiFieldDescriptionText": "Fecha de Emisión"
                },
                {
                    "fieldKey": "dateOfExpiration",
                    "fieldFriendlyName": "Fecha de Vencimiento",
                    "uiFieldDescriptionText": "Fecha de Vencimiento"
                },
                {
                    "fieldKey": "issuingAuthority",
                    "fieldFriendlyName": "Autoridad Emisora",
                    "uiFieldDescriptionText": "Autoridad Emisora"
                }
            ],
            "groupKey": "idInfo"
        }
    ]
};
